import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PermissionService } from '../../security/services/permission.service';
import { ONGLETS_CRM } from '../../../core/config/crm-onglets';

/**
 * `/crm` (l'entrée unique du menu) : vers le PREMIER onglet permis — le
 * tableau de bord pour qui lit les opportunités, les pistes sinon, etc.
 * Aucun : retour à l'accueil.
 */
export const crmAccueilGuard: CanActivateFn = (): UrlTree => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  const permis = ONGLETS_CRM.find(
    (o) => permissions.isSuperAdmin() || permissions.hasPermission(o.entite, 'READ'),
  );
  return router.parseUrl(permis?.route ?? '/');
};
